import get from 'lodash.get';

import { RESET_STATE } from 'services/auth/constants';

import { ProductsState, ProductsActions } from './types';
import { PRODUCTS_SET, PRODUCT_SET } from './constants';

const initialState: ProductsState = {};

export default function (
    state: ProductsState = initialState,
    action: ProductsActions
): ProductsState {
    switch (action.type) {
        case PRODUCTS_SET:
            return get(action, 'payload', {});
        case PRODUCT_SET:
            return {
                ...state,
                ...get(action, 'payload', {})
            };
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
